import moment from "moment";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useReadableAvailability } from "PFCore/helpers/use_readable_availability";
import { IconName } from "PFTheme/graphics/icons";
import { AvailabilityRule, MatchedActivity } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import { Section } from "../../components";
import css from "./core_information_section.module.scss";

type CoreInformationSectionProps = {
  role: MatchedActivity["activity"];
};

export const CoreInformationSection = ({ role }: CoreInformationSectionProps) => {
  const { t } = useTranslation("marketplace", {
    keyPrefix: "workOpportunities.roleDetails.coreInformation"
  });
  const { readableAvailability } = useReadableAvailability({
    availability: role.metadata.availability as AvailabilityRule
  });

  const daysToApply = role.post_until ? moment(role.post_until).diff(moment(), "days") : 0;

  return (
    <Section>
      <div className={css.mainContainer}>
        {daysToApply >= 0 && (
          <InlineInfo iconName="calendar">{t("daysLeftToApply", { count: daysToApply })}</InlineInfo>
        )}
        {role.metadata.location && <InlineInfo iconName="location">{role.metadata.location}</InlineInfo>}
        {/* TODO: [PROF-849] check proper source of "type" when api development gains steam*/}
        {role.metadata.type && <InlineInfo iconName="department">{role.metadata.type}</InlineInfo>}
        {readableAvailability && <InlineInfo iconName="calendar">{readableAvailability}</InlineInfo>}
      </div>
    </Section>
  );
};

type InlineInfoProps = {
  iconName: IconName;
};

const InlineInfo = ({ iconName, children }: React.PropsWithChildren<InlineInfoProps>) => (
  <div className={css.infoWrapper}>
    <Icon name={iconName} color="paletteBlue2" />
    <Typography variant="bodyRegular" noMargin>
      {children}
    </Typography>
  </div>
);
